<template>
  <div class="pt-2 flex flex-col justify-start items-start">
    <div class="w-full flex flex-col justify-center items-center">
      <div
        class="size-12 bg-green-100 rounded-full flex justify-center items-center"
      >
        <SvgIcon name="success" />
      </div>
      <div class="mt-3 leading-0 text-xl font-semibold">
        {{ $t("auth.registerSuccessTitle") }}
      </div>
      <div class="mt-1 text-center leading-0 text-sm text-gray-500">
        {{ $t("auth.registerSuccessDescription") }}
      </div>
    </div>

    <button @click="login" class="mt-5 auth-form__submit">
      {{ $t("auth.loginButtonText") }}
    </button>
  </div>
</template>

<script>
export default {
  name: "RegisterSuccess",
  methods: {
    login() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.auth-form__submit {
  @apply w-full h-12 bg-[#058242] border-none rounded-lg text-white text-sm;
  cursor: pointer;
}
</style>
